// TODO: rework for right reuse

import http from 'http';
import axios, { type AxiosInstance } from 'axios';

let instance: AxiosInstance;
let urlDummy: string = '';

export default function (url: string) {
  if (!instance || urlDummy !== url) {
    urlDummy = url;

    instance = axios.create({
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        ...(import.meta.server ? { 'Accept-Encoding': 'gzip, deflate' } : {}),
      },
      ...(!url.includes('https') && import.meta.server
        ? {
            httpAgent: new http.Agent({
              keepAlive: false,
            }),
          }
        : {}),
    });
  }

  return instance;
}
